import { render, staticRenderFns } from "./Obrigado.vue?vue&type=template&id=1b32efba&scoped=true&"
import script from "./Obrigado.vue?vue&type=script&lang=js&"
export * from "./Obrigado.vue?vue&type=script&lang=js&"
import style0 from "./Obrigado.vue?vue&type=style&index=0&id=1b32efba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32efba",
  null
  
)

export default component.exports